<template>
    <div v-if="loaded" class="nevs-content">
        <ModalAddCustomer :show="showAddCustomerModal" @done="addCustomerDone"></ModalAddCustomer>
        <div class="nevs-content-top-buttons">
            <NevsButton class="success help-save" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="form form-float">
            <NevsSelect v-model="workOrder.customer_id" :ajax="'select/customers'" :error="workOrderValidation.customer_id"
                        :label="$LANG.Get('fields.customer')"></NevsSelect>
            <div v-if="this.selectedCustomer !== null" class="customer-details">
                {{ this.selectedCustomer.address }}<br/>
                {{ this.selectedCustomer.postal_code }} {{ this.selectedCustomer.city }}<br/>
                {{ this.selectedCustomer.country }}<br/>
            </div>
            <NevsButton @click="showAddCustomerModal = true">
                {{ $LANG.Get('buttons.addNewCustomer') }}
            </NevsButton>
        </NevsCard>
        <NevsCard class="form form-float help-dates">
            <NevsDateField v-model="timeOfIssue.date" :error="timeOfIssueValidation.date"
                           :label="$LANG.Get('fields.dateOfIssue')"></NevsDateField>
            <NevsMaskedField v-model="timeOfIssue.time" :error="timeOfIssueValidation.time"
                             :label="$LANG.Get('fields.timeOfIssue')"
                             :mask="'NN:NN:NN'"></NevsMaskedField>
        </NevsCard>
        <NevsCard class="form form-float">
            <NevsSelect v-if="showCurrency" v-model="workOrder.currency" :ajax="currencyEndpoint"
                        :error="workOrderValidation.currency"
                        :label="$LANG.Get('fields.currency')" :readonly="currencyReadonly"></NevsSelect>
            <NevsSelect v-if="mode !== 'add' && mode !== 'copy' && mode !== 'offer'" v-model="workOrder.work_order_status_id"
                        :ajax="'select/work-order-statuses'" :error="workOrderValidation.currency"
                        :label="$LANG.Get('fields.status')"></NevsSelect>
            <NevsSelect v-if="(mode === 'add' || mode === 'copy' || mode === 'offer') && sequences.length > 1"
                        v-model="workOrder.workOrder_sequence_id"
                        :error="workOrderValidation.workOrder_sequence_id" :label="$LANG.Get('fields.sequence')"
                        :options="sequences"></NevsSelect>
            <NevsSelect v-model="workOrder.locale"
                        :error="workOrderValidation.locale" :label="$LANG.Get('fields.language')"
                        :ajax="'select/languages'"></NevsSelect>
        </NevsCard>
        <NevsCard class="items-card">
            <NevsSelect v-model="selectedProduct" :ajax="'select/products'" :error="workOrderValidation.items"
                        :label="$LANG.Get('labels.selectItem')" class="item-select help-item"></NevsSelect>
            <NevsButton class="details-button" @click="toggleDetails()"><i class="fa-solid fa-eye"></i> {{ $LANG.Get('buttons.details') }}</NevsButton>
            <div class="items-container">
                <table v-show="workOrder.items.length !== 0" class="items-table">
                    <thead>
                    <tr class="items-table-header">
                        <td v-for="(header, key) in headers" :key="key" :style="{'width': header.width}">{{
                                header.text
                            }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in workOrder.items" :key="key">
                        <td class="items-table-buttons">
                            <NevsButton @click="removeItemClick(key)"><i class="fa-solid fa-trash"></i></NevsButton>
                        </td>
                        <td>
                            <NevsTextField v-model="item.description" :readonly="item.product_id!==null"></NevsTextField><br />
                            <NevsTextArea v-if="showDetails" v-model="item.details"></NevsTextArea>
                        </td>
                        <td>
                            <NevsSelect v-model="item.measurement_unit_id" :readonly="item.product_id!==null"
                                        :ajax="'select/measurement-units'"></NevsSelect>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.price"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.quantity" :decimal-places="3"
                                             :thousand-separator="''"></NevsNumberField>
                        </td>
                        <td v-if="workOrder.tax_system && !workOrder.ppo">
                            <NevsNumberField v-model="item.tax"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.discount"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField :readonly="true" v-model="item.total"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table v-show="workOrder.items.length !== 0" class="summary-table">
                    <tbody>
                    <tr>
                        <td class="sub-table-left">{{ $LANG.Get('labels.additionalDiscount') }} (%):</td>
                        <td class="sub-table-right">
                            <NevsNumberField v-model="workOrder.discount" :thousand-separator="''"></NevsNumberField>
                        </td>
                    </tr>
                    <tr v-for="(base, key) in taxBases" :key="key">
                        <td>
                            {{ $LANG.Get('labels.taxBase') }} {{ base.base }} ({{ workOrder.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="base.value" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $LANG.Get('fields.total') }} ({{ workOrder.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="total" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="nevs-clear-float"></div>
            </div>
        </NevsCard>
        <NevsCard class="footer-container">
            <NevsTextArea v-model="workOrder.note" :error="workOrderValidation.note"
                          :label="$LANG.Get('fields.note')"></NevsTextArea>
            <NevsTextArea v-model="workOrder.footer" :error="workOrderValidation.footer"
                          :label="$LANG.Get('fields.footer')"></NevsTextArea>
            <NevsCheckbox v-model="workOrder.ppo" :label="$LANG.Get('fields.ppo')" class="help-ppo"></NevsCheckbox>
            <NevsTextField v-if="workOrder.ppo" v-model="workOrder.ppo_text"
                           :label="$LANG.Get('fields.ppoText')"></NevsTextField>
            <NevsSelect class="bank-field" v-if="ibanOptions.length > 1" :label="$LANG.Get('fields.iban')"
                        v-model="workOrder.iban" :options="ibanOptions"></NevsSelect>
            <NevsSelect class="bank-field" v-if="swiftOptions.length > 1" :label="$LANG.Get('fields.swift')"
                        v-model="workOrder.swift" :options="swiftOptions"></NevsSelect>
        </NevsCard>
    </div>
</template>

<script>
import WorkOrder from '@/models/WorkOrder.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import Big from 'big.js';
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsMaskedField from "@/components/nevs/NevsMaskedField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import ModalAddCustomer from "@/components/modals/ModalAddCustomer.vue";
import moment from "moment";

export default {
    name: "EntityWorkOrder",
    components: {
        ModalAddCustomer,
        NevsCheckbox,
        NevsTextArea,
        NevsNumberField, NevsTextField, NevsMaskedField, NevsDateField, NevsSelect, NevsButton, NevsCard
    },
    data() {
        return {
            loaded: false,
            mode: this.$route.params.mode,
            workOrder: new WorkOrder({
                id: this.$route.params.id,
                iban: this.$store.state.user.client.iban[0],
                swift: this.$store.state.user.client.swift[0]
            }),
            workOrderValidation: new WorkOrder({}, true),
            selectedCustomer: null,
            selectedProduct: null,
            taxBases: [],
            tempTaxBases: [],
            total: 0,
            currencyReadonly: false,
            originalCustomerId: null,
            newCustomerData: null,
            customerChanged: false,
            timeOfIssue: {
                date: null,
                time: null
            },
            timeOfIssueValidation: {
                date: '',
                time: ''
            },
            sequences: [],
            showCurrency: false,
            currencyEndpoint: 'select/currencies',
            showAddCustomerModal: false,
            showDetails: false,
            offerNumber: ''
        }
    },
    computed: {
        headers() {
            let headers = [
                {
                    text: '',
                    sortable: false,
                    value: 'actions',
                    width: '50px',
                    class: 'pa-0'
                },
                {
                    text: this.$LANG.Get('fields.description'),
                    sortable: false,
                    value: 'description',
                    class: 'pa-0 description-width'
                },
                {
                    text: this.$LANG.Get('fields.measurementUnit'),
                    sortable: false,
                    value: 'measurement_unit',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.price') + ' (' + this.workOrder.currency + ')',
                    sortable: false,
                    value: 'price',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.quantity'),
                    sortable: false,
                    value: 'quantity',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.discount'),
                    sortable: false,
                    value: 'discount',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.total') + ' (' + this.workOrder.currency + ')',
                    sortable: false,
                    value: 'total',
                    class: 'pa-0',
                    width: "100px"
                }
            ]
            if (this.workOrder.tax_system && !this.workOrder.ppo) {
                headers.splice(5, 0, {
                    text: this.$LANG.Get('fields.tax'),
                    sortable: false,
                    value: 'tax',
                    class: 'pa-0',
                    width: "100px"
                })
            }
            return headers;
        },
        ibanOptions() {
            let options = [];
            let current = this.workOrder.iban;
            let currentExists = false;
            for (let iban of this.$store.state.user.client.iban) {
                if (iban === current) currentExists = true;
                options.push({
                    label: iban,
                    value: iban
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        },
        swiftOptions() {
            let options = [];
            let current = this.workOrder.swift;
            let currentExists = false;
            for (let swift of this.$store.state.user.client.swift) {
                if (swift === current) currentExists = true;
                options.push({
                    label: swift,
                    value: swift
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        }
    },
    watch: {
        'workOrder.locale': function () {
            if (this.loaded) {
                let vm = this;
                for (let i = 0; i < this.workOrder.items.length; i++) {
                    if (this.workOrder.items[i].product_id !== null) {
                        this.$API.APICall('get', 'products/' + this.workOrder.items[i].product_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.product['name_' + vm.workOrder.locale] !== undefined) ? data.product['name_' + vm.workOrder.locale] : data.product.name;
                                if (newName != '') vm.workOrder.items[i].description = newName;
                            }
                        }, false);
                    }
                }
                this.workOrder.footer = this.$store.state.user.client['work_order_footer_template_' + this.workOrder.locale];
                this.workOrder.ppo_text = this.workOrder.ppo ? this.$store.state.user.client['ppo_template_' + this.workOrder.locale] : '';
            }
        },
        'workOrder.customer_id': function () {
            if (this.workOrder.customer_id != null) {
                let vm = this;
                this.$API.APICall('get', 'customers/' + this.workOrder.customer_id, {}, (data, success) => {
                    if (success) {
                        vm.selectedCustomer = data.customer;
                    }
                });
            } else {
                this.selectedCustomer = null;
            }
        },
        'selectedProduct': function () {
            if (this.selectedProduct != null) {
                this.addItem();
            }
        },
        'workOrder.items': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'workOrder.ppo': {
            handler: function () {
                this.calculateTotals();
                if (this.loaded) {
                    this.workOrder.ppo_text = this.workOrder.ppo ? this.$store.state.user.client['ppo_template_' + this.workOrder.locale] : '';
                }
            },
            deep: true
        },
        'workOrder.discount': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'workOrder.currency': {
            handler: function () {
                this.loadCurrencyRate();
            },
            deep: true
        },
        'timeOfIssue': {
            handler: function () {
                this.showCurrency = false;
                this.currencyEndpoint = 'select/currencies';
                if (this.timeOfIssue.date + ' ' + this.timeOfIssue.time < this.$store.state.settings.EUR_TRANSITION) {
                    this.currencyEndpoint = 'select/currencies-hrk';
                }
                this.$nextTick(() => {
                    this.workOrder.time_of_issue = this.timeOfIssue.date + ' ' + this.timeOfIssue.time;
                    this.showCurrency = true;
                });
            },
            deep: true
        },
        'workOrder.time_of_issue': {
            handler: function () {
                this.timeOfIssue.date = this.workOrder.time_of_issue.split(' ')[0];
                this.timeOfIssue.time = this.workOrder.time_of_issue.split(' ')[1];
                if (this.workOrder.time_of_issue > moment().format('YYYY-MM-DD') + ' 23:59:59') {
                    this.workOrder.currency = this.$HELPERS.GetDefaultCurrency();
                    this.currencyReadonly = true;
                    this.loadCurrencyRate();
                } else {
                    this.currencyReadonly = false;
                    this.loadCurrencyRate();
                }
            },
            deep: true
        }
    },
    methods: {
        addCustomerDone(customerId) {
            this.showAddCustomerModal = false;
            if (customerId) {
                this.workOrder.customer_id = customerId;
            }
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        loadCurrencyRate() {
            let vm = this;
            let oldRate = this.workOrder.currency_rate;
            let loaded = this.loaded;
            this.$API.APICall('get', 'currencies/' + this.workOrder.currency, {date: this.workOrder.time_of_issue}, (data, success) => {
                if (success) {
                    if (data.rate != null) {
                        vm.workOrder.currency_rate = data.rate;
                        if (loaded) {
                            for (let index in vm.workOrder.items) {
                                let item = vm.workOrder.items[index];
                                let price = Big(item.price);
                                vm.workOrder.items[index]['price'] = ((price * oldRate).toFixed(2) / Big(data.rate)).toFixed(2);
                            }
                        }
                    }
                }
            }, false);
        },
        calculateTotals() {
            this.tempTaxBases = [];
            this.total = Big(0);
            for (let index in this.workOrder.items) {
                let item = this.workOrder.items[index];
                let total = Big(item.price).times(Big(item.quantity));
                total = Big(total.toFixed(2));
                let item_discount = total.times(Big(item.discount)).div(Big(100));
                item_discount = item_discount.toFixed(2);
                total = total.minus(item_discount);
                total = Big(total.toFixed(2));
                let total_with_discount = total;
                let discount_amount = total_with_discount.times(Big(this.workOrder.discount)).div(Big(100));
                discount_amount = Big(discount_amount.toFixed(2));
                total_with_discount = total_with_discount.minus(discount_amount);
                if (this.workOrder.tax_system && !this.workOrder.ppo) {
                    this.addToTempBase(item.tax, total_with_discount);
                }
                this.workOrder.items[index]['total'] = total.toFixed(2);
                this.total = this.total.add(total_with_discount.toFixed(2));
            }
            this.taxBases = JSON.parse(JSON.stringify(this.tempTaxBases));
            if (this.workOrder.tax_system && !this.workOrder.ppo) {
                this.total = Big(0);
                for (let index in this.taxBases) {
                    let currentBase = this.taxBases[index];
                    let currentTaxAmount = (Big(currentBase.value).times(Big(currentBase.base)).div(Big(100))).toFixed(2);
                    this.total = this.total.add(currentTaxAmount).add(Big(currentBase.value));
                }
            }
        },
        addToTempBase(base, value) {
            let term = false;
            for (let index in this.tempTaxBases) {
                let currentBase = this.tempTaxBases[index];
                if (currentBase.base === base) {
                    term = true;
                    currentBase.value = Big(currentBase.value).add(Big(value)).toString();
                }
            }
            if (!term) {
                this.tempTaxBases.push({
                    base: base,
                    value: Big(value).toString()
                });
            }
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            if (this.workOrder.customer_id !== this.originalCustomerId) {
                this.saveAction();
            } else {
                if (!this.customerChanged) {
                    this.saveAction();
                } else {
                    let vm = this;
                    this.$LOCAL_BUS.TriggerEvent('popup', {
                        type: 'confirm',
                        text: this.$LANG.Get('alerts.customerChangesQuestionWorkOrder'),
                        callback: (response) => {
                            if (response) {
                                vm.workOrder.customer_data = JSON.parse(JSON.stringify(vm.newCustomerData));
                                vm.customerChanged = false;
                            }
                            vm.saveAction();
                        }
                    });
                }
            }
        },
        saveAction() {
            let success = true;

            if (this.workOrder.customer_id == null) {
                success = false;
                this.workOrderValidation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.workOrderValidation.customer_id = '';
            }

            if ((this.workOrder.time_of_issue == null) || (!this.$HELPERS.DateTimePattern().test(this.workOrder.time_of_issue))) {
                success = false;
                this.timeOfIssueValidation.time = this.$LANG.Get('labels.timeOfIssueMissing');
            } else {
                this.timeOfIssueValidation.time = '';
            }

            let itemsValidation = '';
            if (this.workOrder.items.length === 0) {
                success = false;
                itemsValidation = this.$LANG.Get('labels.noItems');
            } else {
                itemsValidation = '';
            }
            let termDescription = false;
            let termNegative = false;
            for (let item of this.workOrder.items) {
                if (item.description === '') {
                    termDescription = true;
                    break;
                }
                if (item.quantity < 0 || item.price < 0) {
                    termNegative = true;
                    break;
                }
            }
            if (termDescription) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.emptyItem');
            }
            if (termNegative) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.negativeItem');
            }
            this.workOrderValidation.items = itemsValidation;

            if (success) {
                let data = JSON.parse(JSON.stringify(this.workOrder));
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.mode === 'edit') {
                    action = 'put';
                    addition = '/' + this.workOrder.id;
                }
                this.$API.APICall(action, 'work-orders' + addition, data, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-work-orders', {});
                        if (action === 'post') {
                            vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        } else {
                            vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        }
                        if (vm.mode === 'add' || vm.mode === 'copy' || vm.mode === 'offer') {
                            vm.backClick();
                        }
                    } else {
                        if (data.error === 'invalid sequence later') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.workOrderSequenceLater'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid sequence earlier') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.workOrderSequenceEarlier'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid year') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.workOrderInvalidYear'),
                                type: 'alert'
                            });
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }
                });
            }
        },
        addItem() {
            if (this.selectedProduct === null) return;
            if (this.selectedProduct === -1) {
                let newItem = {
                    description: '',
                    details: '',
                    price: 0,
                    quantity: 1,
                    tax: this.$store.state.settings.DEFAULT_TAX,
                    discount: 0,
                    measurement_unit_id: (this.$store.state.user.client.default_measurement_unit_id !== null) ? this.$store.state.user.client.default_measurement_unit_id : 1,
                    total: 0,
                    product_id: null
                }
                if (!this.$store.state.user.client.tax_system) newItem.tax = 0;
                this.workOrder.items.push(newItem);
                this.$nextTick(() => {
                    this.selectedProduct = null;
                });
            } else {
                let vm = this;
                this.$API.APICall('get', 'products/' + this.selectedProduct, {}, (data, success) => {
                    if (success) {
                        let newItem = {
                            description: (data.product['name_' + vm.workOrder.locale] !== undefined) ? data.product['name_' + vm.workOrder.locale] : data.product.name,
                            details: '',
                            price: data.product.price * this.workOrder.currency_rate,
                            quantity: 1,
                            tax: data.product.tax,
                            discount: 0,
                            measurement_unit_id: data.product.measurement_unit_id,
                            total: 0,
                            product_id: data.product.id
                        }
                        if (this.workOrder.time_of_issue < this.$store.state.settings.EUR_TRANSITION) {
                            newItem.price = data.product.price / this.workOrder.currency_rate;
                        }
                        vm.workOrder.items.push(newItem);
                        vm.selectedProduct = null;
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }, false);
            }
        },
        removeItemClick(index) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.workOrder.items.splice(index, 1);
                    }
                }
            });
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-save',
                html: this.$LANG.Get('help.save'),
                left: -100,
                top: 0,
                width: 150
            },
            {
                class: 'help-back',
                html: this.$LANG.Get('help.back'),
                left: 85,
                top: -30,
                width: 300
            },
            {
                class: 'help-dates',
                html: this.$LANG.Get('help.dates'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-item',
                html: this.$LANG.Get('help.item'),
                left: 300,
                top: -30,
                width: 300
            },
            {
                class: 'help-ppo',
                html: this.$LANG.Get('help.ppo'),
                left: 300,
                top: -50,
                width: 500
            }
        ]);

        this.$store.commit('selectMenu', 'workOrders');
        this.$store.commit('selectSubMenu', null);

        this.sequences = this.$store.state.user.work_order_sequences;
        if (this.sequences.length > 0) {
            this.workOrder.work_order_sequence_id = this.$store.state.user.default_work_order_sequence_id;
        } else {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.workOrders'),
                    link: '/work-orders'
                },
                {
                    label: this.$LANG.Get('modules.newWorkOrder'),
                    link: null
                }
            ]);

            this.workOrder.tax_system = this.$store.state.user.client.tax_system;
            this.workOrder.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
            this.workOrder.footer = this.$store.state.user.client['work_order_footer_template_' + this.$store.state.locale];
            this.workOrder.locale = this.$store.state.locale;

            this.$nextTick(() => {
                this.loaded = true;
            });
        } else if (this.mode === 'edit') {
            let vm = this;
            this.$API.APICall('get', 'work-orders/' + this.workOrder.id, {}, (data, success) => {
                if (success) {
                    if (data.work_order !== null) {
                        vm.workOrder.Fill(data.work_order);
                        vm.showDetails = vm.workOrder.items.some(item => item.details && item.details !== '');
                        vm.customerChanged = data.work_order.customer_changed;
                        vm.originalCustomerId = data.work_order.customer_id;
                        vm.newCustomerData = data.work_order.new_customer_data;
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.workOrders'),
                                link: '/work-orders'
                            },
                            {
                                label: vm.workOrder.number,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        } else if (this.mode === 'copy') {
            let vm = this;
            this.$API.APICall('get', 'work-orders/' + this.workOrder.id, {}, (data, success) => {
                if (success) {
                    vm.workOrder.id = 0;
                    vm.workOrder.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
                    vm.workOrder.customer_id = data.work_order.customer_id;
                    vm.workOrder.currency = data.work_order.currency;
                    if (vm.workOrder.time_of_issue >= this.$store.state.settings.EUR_TRANSITION && vm.workOrder.currency === 'HRK') {
                        vm.workOrder.currency = 'EUR';
                    }
                    let items = JSON.parse(JSON.stringify(data.work_order.items));
                    for (let i = 0; i < items.length; i++) {
                        items[i].id = undefined;
                    }
                    vm.workOrder.items = items;
                    vm.showDetails = vm.workOrder.items.some(item => item.details && item.details !== '');
                    vm.workOrder.payment_method_id = data.work_order.payment_method_id;
                    vm.workOrder.ppo = data.work_order.ppo;
                    vm.workOrder.ppo_text = data.work_order.ppo_text;
                    vm.workOrder.discount = data.work_order.discount;
                    vm.workOrder.footer = data.work_order.footer;
                    vm.workOrder.tax_system = vm.$store.state.user.client.tax_system;
                    vm.workOrder.locale = data.work_order.locale;

                    this.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.workOrders'),
                            link: '/work-orders'
                        },
                        {
                            label: this.$LANG.Get('modules.newWorkOrder'),
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        } else if (this.mode === 'offer') {
            let vm = this;
            this.$API.APICall('get', 'offers/' + this.workOrder.id, {}, (data, success) => {
                if (success) {
                    vm.offerNumber = data.offer.number;

                    let tempData = JSON.parse(JSON.stringify(data.offer));
                    tempData.id = 0;
                    tempData.offer_id = parseInt(vm.$route.params.id);
                    tempData.tax_system = vm.$store.state.user.client.tax_system;
                    tempData.work_order_sequence_id = vm.$store.state.user.default_work_order_sequence_id;

                    tempData.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');

                    tempData.customer_changed = false;
                    tempData.locale = data.offer.locale;

                    tempData.footer = vm.$store.state.user.client['work_order_footer_template_' + tempData.locale] + "\n" + vm.$LANG.Get('texts.workOrderForOffer_' + tempData.locale).replace('%offer%', vm.offerNumber);

                    for (let index in tempData.items) {
                        tempData.items[index].id = undefined;
                    }

                    if (tempData.time_of_issue >= this.$store.state.settings.EUR_TRANSITION && tempData.currency === 'HRK') {
                        tempData.currency = 'EUR';
                    }

                    vm.workOrder.Fill(tempData);
                    vm.showDetails = tempData.items.some(item => item.details && item.details !== '');

                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.workOrders'),
                            link: '/work-orders'
                        },
                        {
                            label: this.$LANG.Get('modules.workOrderFromOffer') + ' ' + vm.offerNumber,
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 300px;
    margin-bottom: 10px;
}

.form-float {
    width: 300px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 15px;
}

.form-float h2 {
    margin: 0 0 5px;
}

.customer-details {
    margin: 5px;
}

.items-card {
    clear: both;
}

.details-button {
    float: right;
    margin-bottom: 5px;
}

.items-container {
    clear: both;
    overflow-x: auto;
    white-space: nowrap;
}

.footer-container {
    margin-top: 10px;
    width: calc(100% - 20px);
}

.item-select {
    max-width: 500px;
}

.items-table {
    width: 100%;
    min-width: 1000px;
}

.items-table-header td {
    font-size: 12px;
    padding-left: 5px;
}

.items-table td {
    vertical-align: top;
}

.items-table-buttons {
    text-align: center;
}

.items-table-buttons span {
    cursor: pointer;
}

/* Match the button box to the field input (same 13px vertical padding) and offset it by the
   field wrapper's 5px top padding, so the buttons line up with the first row of inputs. */
.items-table-buttons .nevs-button {
    padding: 13px;
    margin-top: 5px;
}

.summary-table {
    float: right;
    margin-top: 30px;
    width: 400px;
}

.bank-field {
    max-width: 400px;
}

@media only screen and (max-width: 500px) {
    .summary-table {
        float: none;
    }
}

</style>